import { X } from "react-feather";
import styled from "styled-components";
import InputNumber from "../../components/InputNumber";
import { Heading6, Subtitle1 } from "../../components/Typography";
import { COLOR_WHITE, COLOR_YELLOW } from "../../constants/colors";

type ProductProps = {
  image: string;
  name: string;
  description: string;
  price: number;
  qty: number;
  storedAt: number;
  removeProduct: (storedAt: number) => void;
  setQty: (storedAt: number, qty: number) => void;
};

const Container = styled.div`
  display: flex;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: auto;
`;

const ImgWrapper = styled.div`
  width: 195px;
  height: 195px;
  margin: 0 40px;
  position: relative;
  background-color: ${COLOR_WHITE};
  overflow: hidden;
  clip-path: polygon(25% 0, 80% 0%, 100% 0, 100% 75%, 75% 100%, 0 100%, 0% 80%, 0 25%);

  @media (max-width: 768px) {
    width: 142px;
    height: 142px;
    margin: 0 20px;
  }
`;

const IcClose = styled(X)`
  color: ${COLOR_YELLOW};
  width: 48px;
  height: 48px;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 24px;
    height: 24px;
  }
`;

const ImgProduct = styled.img`
  position: absolute;
  z-index: 2;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Title = styled.div`
  ${Heading6}
  color: ${COLOR_WHITE};

  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Description = styled.div`
  ${Subtitle1}
  color: ${COLOR_WHITE};
`;

const Price = styled.div`
  ${Heading6}
  color: ${COLOR_WHITE};
`;

function Product(props: ProductProps) {
  const { image, name, description, price, qty, setQty, storedAt, removeProduct } = props;

  const handleSetQty = (newQty: number) => {
    setQty(storedAt, newQty);
  };

  const handleRemove = () => {
    removeProduct(storedAt);
  };

  return (
    <Container>
      <Wrapper>
        <IcClose size={48} color={COLOR_YELLOW} onClick={handleRemove} />
        <ImgWrapper>
          <ImgProduct src={image} alt={name} className="w-100" />
        </ImgWrapper>
      </Wrapper>
      <div>
        <Title className="mb-2">{name}</Title>
        <Description>Option: {description}</Description>
        <Price className="my-3">${price.toFixed(2)}</Price>
        <InputNumber value={qty} onChange={handleSetQty} />
      </div>
    </Container>
  );
}

export default Product;
